import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dailypnl: localStorage.getItem('dailypnl')
    ? JSON.parse(localStorage.getItem('dailypnl'))
    : null,
};

const dailypnlSlice = createSlice({
  name: 'dailypnl',
  initialState,
  reducers: {
    setDailypnl: (state, action) => {
      state.dailypnl = action.payload.dailypnl;
      localStorage.setItem('dailypnl', JSON.stringify(action.payload.dailypnl));
    },
  },
});

export const {setDailypnl } = dailypnlSlice.actions;

export default dailypnlSlice.reducer;
